import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import { buyOrderSpot, sellOrderSpot } from "./helperFunction";
import axios from "axios";

interface spot {
    themeValue:string,
    orderType: string,
    isBuyLoading: boolean,
    isSellLoading: boolean,
    isCreatedOrder:boolean,
    sellOrderInfo: {
        targetPrice: string
        sumAmount: string
    },
    buyOrderInfo: {
        targetPrice: string,
        sumAmount: string,
    }
}
const initialState: spot = {
    themeValue:'',
    orderType: 'limit',
    isBuyLoading: false,
    isSellLoading: false,
    isCreatedOrder:false,
    sellOrderInfo: {
        targetPrice: '',
        sumAmount: '',
    },
    buyOrderInfo: {
        targetPrice: '',
        sumAmount: '',
    }
};
export const spot = createSlice({
    name: "spot",
    initialState,
    reducers: {
        orderType: (state, action: PayloadAction<string>) => {
            console.log('action.payload', action.payload)
            state.orderType = action.payload
        },
        sellOrder: (state: any, action: PayloadAction<{ targetPrice: string, sumAmount: string }>) => {
            
            state.buyOrderInfo = action.payload
        },
        buyOrder: (state: any, action: PayloadAction<{ targetPrice: string, sumAmount: string }>) => {
          
            state.sellOrderInfo = action.payload
        },
        updateIsCreated:(state:any,action:PayloadAction)=>{
            state.isCreatedOrder= !state.isCreatedOrder
        },
        updateTheme:(state:any,action:PayloadAction<string>)=>{
            state.themeValue= action.payload
        }
    },
    extraReducers: {
        [sellOrderSpot.pending.type]: (state: any) => {
            state.isSellLoading = true
        },
        [sellOrderSpot.fulfilled.type]: (state: any, action: PayloadAction<string[]>) => {

            state.sellOrder = action.payload
            state.isSellLoading = false
        },
        [sellOrderSpot.rejected.type]: (state: any) => {
            state.isSellLoading = false
        },
        [buyOrderSpot.pending.type]: (state: any) => {
            state.isBuyLoading = true
        },
        [buyOrderSpot.fulfilled.type]: (state: any, action: PayloadAction<string[]>) => {
            state.buyOrder = action.payload
            state.isBuyLoading = false
        },
        [buyOrderSpot.rejected.type]: (state: any) => {
            state.isBuyLoading = false
        },
    }
});
export const { orderType ,sellOrder ,buyOrder,updateIsCreated,updateTheme} = spot.actions;

export default spot.reducer;
